import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

/** Debounce a fast-changing value so we don't hit the API on every keystroke. */
function useDebounced(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

/**
 * Live search over the academy's registered students.
 * Returns [{ id, name, document, hours_balance }].
 * Only runs once `enabled` is true and the (debounced) query is non-empty.
 */
function useStudentSearch(query, { enabled = true } = {}) {
  const debounced = useDebounced(query ?? "", 250);
  const term = debounced.trim();

  return useQuery({
    queryKey: ["teacher", "student-search", term],
    queryFn: async () => {
      const res = await apiClient.get("/api/v1/students/search/", {
        params: term ? { q: term } : {},
      });
      return res.data;
    },
    enabled: enabled && term.length >= 1,
    keepPreviousData: true,
  });
}

export { useStudentSearch };
